<template>
  <div id="houseList" class="houseList">
    <div class="top">
      <div class="top_title">
        <div class="title">
          <h1>租房/房源</h1>
          <a-button class="el_button el-button--primary" type="primary" @click="addHouse"> 新增房源</a-button>
        </div>
      </div>
      <div class="searchBox">
        <div style="width: 100%">
          <a-row class="paddingL20">
            <a-col :span="5">
              <a-form-item class="search">
                <a-input v-model="form.search" placeholder="智能搜索" @pressEnter="pressEnterSearch">
                  <a-icon slot="prefix" type="search" />
                </a-input>
              </a-form-item>
            </a-col>
          </a-row>
          <a-form v-if="downShow" :label-col="labelCol" :model="searchForm" :wrapper-col="wrapperCol">
            <a-row class="paddingL20">
              <a-col :span="5">
                <a-form-item label="区域">
                  <a-select
                    v-model="form.districtIdList"
                    class="w150"
                    mode="multiple"
                    option-filter-prop="children"
                    show-search
                    @change="regionChange"
                  >
                    <a-select-option v-for="item in districtList" :key="item.areaId" :value="item.areaId">{{
                      item.areaName
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="商圈">
                  <a-select
                    v-model="form.businessDistrictIdList"
                    class="w150"
                    mode="multiple"
                    option-filter-prop="children"
                    show-search
                    @change="businessDistrictMethod"
                  >
                    <a-select-option v-for="item in businessDistrictList" :key="item.id" :value="item.id">{{
                      item.businessDistrictName
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="街道">
                  <a-select
                    v-model="form.streetIdList"
                    class="w150"
                    mode="multiple"
                    option-filter-prop="children"
                    show-search
                  >
                    <a-select-option v-for="item in streetList" :key="item.id" :value="item.id">{{
                      item.streetFullName
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :style="{ display: 'inline-block', width: '100%' }" class="mj" label="面积">
                  <a-input v-model="form.startAcreage" class="w75" type="text" @input="intValidate('startAcreage')" />
                  -

                  <a-input v-model="form.endAcreage" class="w75" type="text" @input="intValidate('endAcreage')" />
                  m²
                </a-form-item>
              </a-col>
            </a-row>
            <a-row class="paddingL20">
              <a-col :span="5">
                <a-form-item label="类型">
                  <a-select v-model="form.shopType" class="w150">
                    <a-select-option v-for="item in shopType" :key="item.dictValue" :value="item.dictValue">{{
                      item.dictLabel
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="5">
                <a-form-item label="楼层">
                  <!-- mode="multiple" -->
                  <a-select v-model="form.houseFloorTypeList" :show-arrow="true" class="w75" @change="houseFloorChange">
                    <a-select-option v-for="item in floorTypeOpts" :key="item.dictLabel" :value="item.dictValue">
                      {{ item.dictLabel }}
                    </a-select-option>
                  </a-select>
                  <a-input
                    v-if="form.houseFloorTypeList === '1'"
                    v-model="form.houseFloor"
                    :maxLength="7"
                    class="w75 ml5"
                    placeholder="楼层数"
                    type="text"
                    @input="intValidate('houseFloor')"
                  />
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item label="可否餐饮">
                  <a-select
                    v-model="form.alloweCateringTypeIdList"
                    class="w150"
                    mode="multiple"
                    option-filter-prop="children"
                    show-search
                  >
                    <a-select-option v-for="item in repastType" :key="item.dictValue" :value="item.dictValue">{{
                      item.dictLabel
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }" label="状态">
                  <a-select v-model="form.houseStatus" class="w150 mr10">
                    <a-select-option v-for="item in houseStatusData" :key="item.dictLabel" :value="item.dictValue">{{
                      item.dictLabel
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>

            </a-row>
            <a-row class="paddingL20">
              <a-col :span="8">
                <a-form-model-item
                  :label-col="{ span: 4 }"
                  :wrapper-col="{ span: 20 }"
                  label="租金"
                  prop="rentExpenseStart"
                >
                  <a-input
                    v-model="time.rentExpenseStart"
                    :maxLength="7"
                    class="w75"
                    placeholder="开始"
                    type="text"
                    @change="timeSwitching"
                    @input="intValidate('rentExpenseStart')"
                  />
                  -
                  <a-input
                    v-model="time.rentExpenseEnd"
                    :maxLength="7"
                    class="w75 mr10"
                    placeholder="结束"
                    type="text"
                    @change="timeSwitching"
                    @input="intValidate('rentExpenseEnd')"
                  />&nbsp;

                  <a-select v-model="flag" placeholder="月租金" style="width: 120px">
                    <a-select-option :value="2">不限</a-select-option>
                    <a-select-option :value="0">月租单价</a-select-option>
                    <!-- 日租金 -->
                    <a-select-option :value="1">月租金</a-select-option>
                  </a-select>
                </a-form-model-item>

              </a-col>

              <a-col :span="10">
                <a-form-item
                  :label-col="{ span: 3 }"
                  :wrapper-col="{ span: 21 }"
                  label="维护人">
                  <a-tree-select
                    v-model="mixin_deptId"
                    :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
                    :replaceFields="replaceFields"
                    :tree-data="deptOptions"
                    placeholder="部门"
                    style="width:180px"
                    tree-default-expand-all
                    @change="handleChangeTree"
                    @select="handleSelectTree"
                  >
                  </a-tree-select>
                  -
                  <a-select
                    v-model="form.accendantId"
                    placeholder="请选择人员"
                    style="width:180px"
                    @dropdownVisibleChange="handleOption($event)"
                  >
                    <a-select-option v-for="item in userList" :key="item.userId" :value="item.userId">
                      {{ item.nickName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="6">
                <a-form-item :label-col="{ span: 7 }" :wrapper-col="{ span: 16 }" label="有无转让费">
                  <a-select v-model="form.isHaveTransferFee" class="w150 mr10">
                    <a-select-option v-for="item in weatherOpts" :key="item.dictLabel" :value="item.dictValue">{{
                      item.dictLabel
                    }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
            </a-row>
            <a-row class="paddingL20">
              <a-col :span="8">
                <a-form-item
                  label="日期"
                  :label-col="{ span: 4}"
                  :wrapper-col="{ span: 20 }">
                  <a-select v-model="form.dateType" class="w150 mr10" default-value="" @change="rqselectMethod">
                    <a-select-option key="0" value="">全部</a-select-option>
                    <a-select-option key="1" value="1">跟进日期</a-select-option>
                    <a-select-option key="2" value="2">录入日期</a-select-option>
                  </a-select>
                  <template v-if="form.dateType">
                    <a-date-picker v-model="form.startTime" :disabled="rqflag" style="width: 118px" />
                    -
                    <a-date-picker v-model="form.endTime" :disabled="rqflag" style="width: 118px" />
                  </template>
                </a-form-item>

              </a-col>

              <a-col :span="6">
                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" label="创建人">
                  <a-select
                    v-model="form.createUser"
                    placeholder="请选择人员"
                    style="width:180px"
                    @dropdownVisibleChange="handleOption($event)"
                  >
                    <a-select-option v-for="item in createByUserOptions" :key="item.userName" :value="item.userName">
                      {{ item.nickName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>
              </a-col>
              <a-col :span="8">
                <a-form-item :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }" label="行业">
                  <a-select
                    v-model="form.industryCategoryJsonId"
                    mode="multiple"
                    option-filter-prop="children"
                    show-search
                    style="width:160px"
                    @change="getSubIndustryList"
                  >
                    <a-select-option v-for="item in canIndustryList" :key="item.id" :value="item.id">{{
                      item.industryCategoryName
                    }}
                    </a-select-option>
                  </a-select>

                  <a-select
                    v-model="form.industrySubclassJsonId"
                    class="w150 ml5"
                    mode="multiple"
                    option-filter-prop="children"
                    show-search
                    style="width:160px"
                  >
                    <a-select-option v-for="item in canSubIndustryList" :key="item.id" :value="item.id">
                      {{ item.industryCategoryName }}
                    </a-select-option>
                  </a-select>
                </a-form-item>

              </a-col>

            </a-row>
            <a-row>
              <a-col :span="15"></a-col>
              <a-col :span="8" style="margin-top:5px;display:flex;justify-content: flex-start;">
                <div style="margin-bottom:10px">
                  <a-button
                    class="btn mr10"
                    style="border: 1px solid var(--ThemeColor); color: var(--ThemeColor)"
                    @click="reset"
                  >重置
                  </a-button
                  >
                  <a-button class="btn mr10" type="primary" @click="searchBtn">查询</a-button>
                  <a-button v-hasPermi="['houses:rentHouseInfo:export']" type="primary" @click="export_houseList" class="mr10">
                    <a-icon type="download" />
                    导出
                  </a-button>
                  <a-button type="primary" @click="exportHouseAnalyze">
                    <a-icon type="download" />
                    导出房源分析
                  </a-button>
                </div>
              </a-col>
            </a-row>

          </a-form>
          <!-- <a-row style="text-align: center; color: #628dad">
            <p @click="downShow = !downShow" style="cursor: pointer">
              更多
              <a-icon type="down" v-if="!downShow" />
              <a-icon type="up" v-if="downShow" />
            </p>
          </a-row> -->
        </div>
        <!-- <a-button class="new-btn el_button el-button--primary" type="primary" @click="addHouse">新增房源</a-button> -->
      </div>
    </div>
    <div class="midhr"></div>
    <div class="content" style="padding: 20px">
      <a-tabs
        :defaultActiveKey="activeNum"
        class="menu"
        type="card"
        @change="HouseMethod"
      ><!-- v-if="" -->
        <a-tab-pane v-for="(item, index) in getTabs" :key="index + 1" :tab="item.title"></a-tab-pane>
      </a-tabs>
      <ListItem
        ref="ListItem"
        :activeNum="activeNum"
        :dateTypeOpts="dateTypeOpts"
        :houseResourceType="form.houseResourceType"
        :isSell="isSell"
        :records="records"
        :sort="sort"
        :sortType="form.sortType"
        @dateTypeChangeHandle="dateTypeChangeHandle"
        @houselistsort="houselistsort"
      ></ListItem>
      <a-pagination
        v-if="records.length > 0"
        :current="form.pageNum"
        :page-size="form.pageSize"
        :pageSizeOptions="pagination.pageSizeOptions"
        :showTotal="(total) => `共 ${total} 条`"
        :total="pagination.total"
        class="dateli"
        show-size-changer
        @change="onChange"
        @showSizeChange="onChange"
      />
    </div>
    <div v-show="loading" class="topcenter">
      <LoadingModel></LoadingModel>
    </div>
  </div>
</template>

<script>
// 引入图标
import './../details/detail/assets/font/iconfont.css'
import LoadingModel from '@/components/Loading'
import houseListVue from '@/components/houseList/houseList.vue'
import houseApi from '@/api/system/houses/house.js'
import touristApi from '@/api/system/tourist/tourist'
import moment from 'moment'
import { treeSelectMixin } from '@/mixin/treeSelect'
import { industryClassSelMixin } from '@/mixin/industrySelect'
import ListItem from './components/listItem.components.vue'
import {
  getBeginLastMonth,
  getBeginLastWeek,
  getBeginMonth,
  getBeginWeek,
  getBeginYesterday,
  getEndLastMonth,
  getEndLastWeek,
  getEndMonth,
  getEndYesterday,
  getYMD
} from '@/utils/date.js'

import { locationSelectMixin } from '@/mixin/locationSelect'

const tabsList = [
  {
    key: 1,
    title: '全部房源'
  },
  {
    key: 2,
    title: '我的房源'
  },
  {
    key: 3,
    title: '门店公盘'
  },
  {
    key: 4,
    title: '公司公盘'
  },
  {
    key: 5,
    title: '即将掉盘'
  },
  {
    key: 6,
    title: '下架'
  }
]

export default {
  // name: 'RentHouseList',
  name: 'HousesList',
  components: {
    houseListVue,
    ListItem,
    LoadingModel
  },
  computed: {
    // 获取tabs,如总经理等无我的房源
    getTabs () {
      const arr = ['ZJL']
      const loginRole = this.$getters.userInfo.data.roles
      let status = false
      loginRole.forEach(el => {
        if (arr.includes(el)) {
          status = true
        }
      })
      if (status) {
        this.tabsList = tabsList.filter(el => el.key == 1)
      } else {
        this.tabsList = tabsList
      }
      return this.tabsList
    }
  },
  mixins: [treeSelectMixin, locationSelectMixin, industryClassSelMixin],
  data () {
    return {
      time: {
        rentExpenseStart: '',
        rentExpenseEnd: ''
      },
      flag: 1,
      tabsList,
      isSell: false, // 是否为售房管理
      activeNum: 1,
      rentUnit: '', // 租金单位
      form_startRentFee: undefined, // 租金开始（显示的）
      form_endRentFee: undefined, // 租金结束（显示的）
      rentStartDate: undefined, // 日租金开始
      rentEndDate: undefined, // 日租金结束
      rentStartMonth: undefined, // 月租金开始
      rentEndMonth: undefined, // 月租金结束
      // 加载
      loading: false,
      // 信息
      AllList: [],
      // 日期控制禁用
      rqflag: true,
      // 租金切换
      zujinfalg: true,
      // 列表数据
      records: [],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      // 查询表单
      searchForm: {
        rqselect: 'all',
        rqstart: '',
        rqend: ''
      },
      pagination: {
        current: 1,
        total: 1,
        size: 3,
        pageSizeOptions: ['10', '20', '30']
      },
      sort: 1,
      direction: 'down',
      direction2: 'down',
      direction3: 'down',
      direction4: 'down',
      direction5: 'down',
      direction6: 'down',
      form: {
        hourseSort: 1,
        dateType: '',
        houseResourceType: 1,
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        sortType: 'DESC',
        // sortType: '',
        storeId: undefined, // 门店ID（维护人）
        teamId: undefined, // 部门ID（维护人）
        accendantId: '', // 维护人

        alloweCateringTypeId: [],
        businessDistrictId: [],
        districtId: [],
        streetId: [],

        // 多选
        districtIdList: [],
        businessDistrictIdList: [],
        alloweCateringTypeIdList: [],
        streetIdList: [],

        endAcreage: undefined,
        endInMoreNum: '',
        endRentFee: null,
        endTime: '',
        houseFloor: '',
        houseStatus: '1',
        isAsc: '',
        orderByColumn: '',
        search: '',
        shopType: '',
        startAcreage: undefined,
        startInMoreNum: '',
        startRentFee: null,
        startTime: '',
        transferFee: '',
        region: undefined,

        industryCategoryId: undefined, // 行业分类ID	query	false	string
        industrySubclassId: undefined, // 经营行业ID	query	false	string
        industryCategoryJsonId: [], // 行业大类ID（可经营）(多选，以“，”隔开)
        industrySubclassJsonId: [], // 行业小类ID（可经营）	(多选，以“，”隔开)
        // 楼层
        houseFloorTypeList: '',
        startHouseFloor: '',
        endHouseFloor: '',
        isHaveTransferFee: '', // 是否接受转让费 字典表类型：sys_yes_no
        createUser: ''
      },
      // 维护人 部门
      newForm: {
        deptId: ''
      },
      // 查询框更多按钮事件
      downShow: true,
      // 房源状态(有效,已租,我租,不租,错误)
      houseStatusData: [{ dictLabel: '全部', dictValue: '' }],
      // 区域列表
      districtData: [],
      // 商圈列表
      businessDistrict: [],
      // 商铺类型
      shopType: [{ dictLabel: '全部', dictValue: '' }],
      // 街道列表
      StreetData: [],
      // 带看日期范围
      dateTypeOpts: [
        { id: 1, name: '今日' },
        { id: 2, name: '昨日' },
        { id: 3, name: '本周' },
        { id: 4, name: '上周' },
        { id: 5, name: '本月' },
        { id: 6, name: '上月' },
        { id: 7, name: '全部' }
      ],

      // 楼层数
      floorData: [],
      // 楼层类型
      floorTypeOpts: [{ dictLabel: '全部', dictValue: '' }],
      weatherOpts: [{ dictLabel: '全部', dictValue: '' }], // 是否
      // 餐饮类型
      repastType: [],
      // 人员部门
      PersonGav: [],
      a: null,
      // 维护人所属部门id
      PersonId: '',
      // 部门列表
      deptListData: [],
      // 部门对应人员
      depPerson: [],
      userList: [],
      createByUserOptions: []
    }
  },
  created () {
    // 获取房源信息列表
    this.dataList()
    this.getCreateByUserOptions()

    // 获取部门
    this.getDep()
    // 房源状态
    this.getDicts('house_status').then((res) => {
      if (res.code === 200) {
        const list = res.data.filter((item) => item.dictValue !== 4)
        // list.forEach((res) => {
        //   switch (Number(res?.dictValue)) {
        //     case 1:
        //       res.dictLabel = '上架'
        //       break
        //     case 2:
        //       res.dictLabel = '我司成交'
        //       break
        //     case 3:
        //       res.dictLabel = '自行成交'
        //       break
        //     case 4:
        //       res.dictLabel = '无效'
        //       break
        //     case 6:
        //       res.dictLabel = '下架'
        //       break
        //     default:
        //       break
        //   }
        // })
        this.houseStatusData = this.houseStatusData.concat(list)
      }
    })
    this.getDicts('sys_yes_no').then((response) => {
      this.weatherOpts = this.weatherOpts.concat(response.data)
    })
    // 商铺类型
    this.getDicts('shop_type').then((res) => {
      if (res.code === 200) {
        this.shopType = this.shopType.concat(res.data)
      }
    })
    // 楼层数
    this.getDicts('floor_num').then((res) => {
      if (res.code === 200) {
        this.floorData = res.data
      }
    })
    // 楼层类型
    this.getDicts('floor_type').then((res) => {
      if (res.code === 200) {
        this.floorTypeOpts = this.floorTypeOpts.concat(res.data)
      }
    })

    // 维护人所属部门id
    this.getDicts('related_personne_type').then((res) => {
      if (res.code === 200) {
        this.PersonGav = res.data
        this.a = this.PersonGav.find((item) => {
          return item.dictLabel === '维护人'
        })
        this.PersonId = this.a.dictSort
      }
    })

    // 餐饮类型
    this.getDicts('repast_type').then((res) => {
      if (res.code === 200) {
        this.repastType = res.data
      }
    })
  },

  methods: {
    getCreateByUserOptions () {
      touristApi.getCreateByUserOptions().then((res) => {
        if (res.code === 200) {
          this.createByUserOptions = res.data
        }
      })
    },
    // 回车
    pressEnterSearch () {
      this.searchBtn()
    },
    // 租金范围 2=不限 0=月租单价 1=月租金
    timeSwitching () {
      if (this.flag === 1) {
        this.form.startRentFee = this.time.rentExpenseStart
        this.form.endRentFee = this.time.rentExpenseEnd
        this.form.startUnitPrice = ''
        this.form.endUnitPrice = ''
      } else if (this.flag === 0) {
        // this.form.startRentFee = this.time.rentExpenseStart * 30
        // this.form.endRentFee = this.time.rentExpenseEnd * 30

        this.form.startRentFee = ''
        this.form.endRentFee = ''
        this.form.startUnitPrice = this.time.rentExpenseStart
        this.form.endUnitPrice = this.time.rentExpenseEnd
      } else {
        this.form.startRentFee = ''
        this.form.endRentFee = ''
        this.form.startUnitPrice = ''
        this.form.endUnitPrice = ''
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
      }
    },
    // int验证
    intValidate (fieldName) {
      const val =
        fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd' ? this.time[fieldName] : this.form[fieldName]
      const reg = /^[0-9]{1,6}$/
      if (!reg.test(val)) {
        if (fieldName === 'rentExpenseStart' || fieldName === 'rentExpenseEnd') {
          this.time[fieldName] = ''
        } else {
          this.form[fieldName] = ''
        }
      }
    },
    // rentChange () {
    //   // 切换租金单位
    //   const startFee = this.form_startRentFee
    //    const endFee = this.form_endRentFee
    //    if (this.flag === '0') { // 日租金
    //     this.rentUnit = '元/日'
    //     this.form.startRentFee = startFee * 30
    //     this.form.endRentFee = endFee * 30
    //   } else if (this.flag === '1') { // 月租金
    //     this.rentUnit = '元/月'
    //     this.form.startRentFee = startFee
    //     this.form.endRentFee = endFee
    //   } else {
    //      this.rentUnit = undefined
    //      this.form.startRentFee = ''
    //     this.form.endRentFee = ''
    //     this.form_startRentFee = ''
    //     this.form_endRentFee = ''
    //   }
    // },
    // 是否首页进入-即将掉盘
    dataList () {
      if (this.$route.query.str) {
        this.activeNum = '5'
        this.HouseMethod(5)
      } else {
        this.activeNum = '1'
        this.houseList()
      }
    },
    dateTypeChangeHandle (e) {
      this.$refs.ListItem.selectValue = e
      // 日期
      let startTime = ''
      let endTime = ''
      if (e === 1) {
        // 今日
        startTime = getYMD('-', new Date())
        endTime = getYMD('-', new Date())
      } else if (e === 2) {
        // 昨日
        startTime = getYMD('-', getBeginYesterday())
        endTime = getYMD('-', getEndYesterday())
      } else if (e === 3) {
        // 本周
        startTime = getYMD('-', getBeginWeek())
        endTime = getYMD('-', getEndYesterday())
      } else if (e === 4) {
        // 上周
        startTime = getYMD('-', getBeginLastWeek())
        endTime = getYMD('-', getEndLastWeek())
      } else if (e === 5) {
        // 本月
        startTime = getYMD('-', getBeginMonth())
        endTime = getYMD('-', getEndMonth())
      } else if (e === 6) {
        // 上月
        startTime = getYMD('-', getBeginLastMonth())
        endTime = getYMD('-', getEndLastMonth())
      } else if (e === 7) {
        // 所有
        startTime = undefined
        endTime = undefined
      } else {
        startTime = undefined
        endTime = undefined
      }
      this.form.startInMoreTime = startTime // 带看开始时间
      this.form.endInMoreTime = endTime // 带看结束时间
      this.houseList()
    },
    // 房源排序方法
    houselistsort (sortType) {
      this.sort = sortType

      this.form.hourseSort = sortType // 房源排序（1：默认 2：租金(元/月) 3：租金(元/平方米/月) 4：带看 5：面积 6：盘别）
      if (sortType === 2) {
        const direction_ = this.direction2 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction2 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 3) {
        const direction_ = this.direction3 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction3 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 4) {
        const direction_ = this.direction4 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction4 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 5) {
        const direction_ = this.direction5 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction5 = direction_ === 'up' ? 'down' : 'up'
      } else if (sortType === 6) {
        const direction_ = this.direction6 // up 升 down 降
        this.form.sortType = direction_ === 'up' ? 'ASC' : 'DESC'
        this.direction6 = direction_ === 'up' ? 'down' : 'up'
      }
      this.houseList()
    },
    // 查询
    searchBtn () {
      this.houseList()
    },
    // 重置
    reset () {
      // this.form_startRentFee = undefined
      // this.form_endRentFee = undefined
      this.time = {
        rentExpenseStart: '',
        rentExpenseEnd: '',
        startUnitPrice: '',
        endUnitPrice: ''
      }
      this.form = {
        hourseSort: 1,
        houseResourceType: this.form.houseResourceType,
        pageNum: 1,
        pageSize: this.$getters.pageSize,
        sortType: 'DESC',
        storeId: undefined, // 门店ID（维护人）
        teamId: undefined, // 部门ID（维护人）
        accendantId: '', // 维护人
        alloweCateringTypeId: [],
        businessDistrictId: [],
        districtId: [],
        streetId: [],
        // 多选
        districtIdList: [],
        businessDistrictIdList: [],
        alloweCateringTypeIdList: [],
        streetIdList: [],

        dateType: '',
        endAcreage: '',
        endInMoreNum: '',
        endTime: '',
        houseFloor: '',
        houseStatus: '',
        isAsc: '',
        orderByColumn: '',
        search: '',
        shopType: '',
        startAcreage: '',
        startInMoreNum: '',
        startRentFee: undefined,
        endRentFee: undefined,
        startUnitPrice: undefined,
        endUnitPrice: undefined,
        startTime: '',

        transferFee: '',
        businessDistrictName: '',

        industryCategoryId: undefined, // 行业分类ID	query	false	string
        industrySubclassId: undefined, // 经营行业ID	query	false	string
        industryCategoryJsonId: [], // 行业大类ID（可经营）(多选，以“，”隔开)
        industrySubclassJsonId: [], // 行业小类ID（可经营）	(多选，以“，”隔开)
        // 楼层
        houseFloorTypeList: '',
        startHouseFloor: '',
        endHouseFloor: '',
        isHaveTransferFee: '' // 是否接受转让费 字典表类型：sys_yes_no
      }
      this.newForm.deptId = ''
      this.mixin_deptId = undefined
      this.searchBtn()
    },
    onChange (current, pageSize) {
      this.form.pageNum = current
      this.form.pageSize = pageSize

      this.houseList()
    },
    // 房源信息查询列表
    houseList () {
      this.loading = true
      this.records = []
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }
      console.log(' this.form', this.form)
      houseApi.houseInfoList(this.form).then((res) => {
        if (res.code === 200) {
          this.records = res.data.records
          this.pagination.total = res.data.total
          this.loading = false
        } else {
          this.$message.warning('房源信息获取失败')
          this.loading = false
        }
        // this.$nextTick(() => {
        //   const scrollTop = localStorage.getItem('scrollTop')
        //   console.log('scrollTop===', scrollTop)
        //   window.scrollTo(0, scrollTop)
        // })
      })
    },

    // 导出-房源信息查询列表
    export_houseList () {
      if (this.form.startTime) {
        this.form.startTime = moment(this.form.startTime).format('YYYY-MM-DD')
      }
      if (this.form.endTime) {
        this.form.endTime = moment(this.form.endTime).format('YYYY-MM-DD')
      }

      var that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出当前条件下所有数据',
        onOk () {
          that.downloadPost(
            '/houseInfo/export',
            {
              ...that.form
            },
            `p_${new Date().getTime()}.xls`
          )
        },
        onCancel () {
        }
      })
    },
    exportHouseAnalyze () {
      const that = this
      this.$confirm({
        title: '是否确认导出?',
        content: '此操作将导出个人上架房源的所有数据',
        onOk () {
          that.downloadPost(
            '/houseInfo/exportHouseAnalyze',
            {},
            `房源分析_${new Date().getTime()}.xlsx`
          )
        },
        onCancel () {
        }
      })
    },
    // 日期选择事件
    rqselectMethod (val) {
      this.searchForm.rqstart = ''
      this.searchForm.rqend = ''
      if (val === 'all') {
        this.rqflag = true
      } else {
        this.rqflag = false
      }
    },
    // 租金切换方法
    zujin (val) {
      if (val === 1) {
        this.zujinfalg = true // 为日租金
      } else {
        this.zujinfalg = false // 为月租金
      }
    },
    // 部门列表
    getDep () {
      houseApi.deptList().then((res) => {
        if (res.code === 200) {
          this.deptListData = res.data

          // this.districtData = res.data
        }
      })
    },
    getDeptSubHandle (val) {
      this.form.accendantId = ''
      this.getDepPerson(val)
    },
    // 部门下属人员
    getDepPerson (deptId) {
      touristApi.getUserList({ deptId }).then((res) => {
        const { code, rows } = res
        if (code === 200) {
          this.userList = rows
        }
      })
    },
    // 房源分类列表
    HouseMethod (val) {
      this.form.pageNum = 1 // 切换标签时 默认跳转第一页
      this.form.startInMoreTime = undefined // 带看开始时间
      this.form.endInMoreTime = undefined // 带看结束时间
      this.form.sortType = 'DESC'
      this.$refs.ListItem.selectValue = 7
      this.sort = 1
      this.hourseSort = 1 // 切换标签时 刷新排序
      this.form.houseResourceType = Number(val)
      this.activeNum = val
      this.houseList()
    },

    addHouse () {
      sessionStorage.setItem('history', JSON.stringify({ fromPage: 'add' }))
      this.$router.push('/houses/add')
    },
    // 价格-升序
    caretUp () {
    },
    houseFloorChange (e) {
      if (e !== '1') {
        this.form.houseFloor = undefined
      }
    }
  },
  watch: {
    // 监听客户是否点击切换租金单位
    // flag () {
    //     if (this.flag === '1') { // 月租金
    //     this.rentUnit = '元/月'
    //     this.form_startRentFee = this.form.startRentFee
    //     this.form_endRentFee = this.form.endRentFee
    //   } else if (this.flag === '0') { // 日租金
    //      this.rentUnit = '元/日'
    //     this.form_startRentFee = this.form.startRentFee
    //       ? (this.form.startRentFee / 30).toFixed(2)
    //       : this.form_startRentFee
    //     this.form_endRentFee = this.form.endRentFee
    //       ? (this.form.endRentFee / 30).toFixed(2)
    //       : this.form_endRentFee
    //   } else {
    //     this.rentUnit = undefined
    //     this.form_startRentFee = ''
    //     this.form_endRentFee = ''
    //     this.form.startRentFee = ''
    //     this.form.endRentFee = ''
    //   }
    //       // console.log(this.form.startRentFee, '========================this.form.startRentFee')
    //       // console.log(this.form.endRentFee, '========================this.form.endRentFee')
    // }
    flag () {
      if (this.flag === 1) {
        this.time.rentExpenseStart = this.form.startRentFee
        this.time.rentExpenseEnd = this.form.endRentFee
      } else if (this.flag === 0) {
        this.time.rentExpenseStart = this.form.startRentFee
          ? (this.form.startRentFee / 30).toFixed(2)
          : this.time.rentExpenseStart
        this.time.rentExpenseEnd = this.form.endRentFee
          ? (this.form.endRentFee / 30).toFixed(2)
          : this.time.rentExpenseEnd
      } else {
        this.time.rentExpenseStart = ''
        this.time.rentExpenseEnd = ''
        this.form.startRentFee = ''
        this.form.endRentFee = ''
      }
    }
  }
}
</script>
<style>
.menu .ant-tabs-bar {
  width: 100%;
}
</style>
<style lang="less" scoped>
.paddingL20 {
  padding-left: 20px;
}

.mr10 {
  margin-right: 10px;
}

.ml5 {
  margin-left: 5px;
}

.w80 {
  width: 80px;
}

.w75 {
  width: 75px;
}

.w120 {
  width: 120px;
}

.w150 {
  width: 150px;
}

.w180 {
  width: 180px;
}

.house_list_order {
  display: flex;
  align-items: center;
  /* width: 100%; */
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}

.houseList {
  background-color: white;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;

  .top {
    background: #fff;

    .top_title {
      padding: 20px;
      display: flex;
      justify-content: center;
      align-content: center;

      .title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        color: #222222;

        h1 {
          font-size: 20px;
          font-weight: 700;
        }

        button {
          width: 100px;
          height: 40px;
        }
      }

      .room-name {
        flex: 1;

        .fy {
          font-size: 20px;
          font-weight: bold;
          color: #000;
        }

        .cz {
          color: var(--ThemeColor);
          font-weight: bold;
          margin-left: 15px;
        }
      }

      .btns {
        .btn {
          background-color: var(--ThemeColor);
          height: 50px;
          width: 102px;
          border-radius: 10px;
          border: none;
        }
      }
    }

    .searchBox {
      margin-top: 13px;
      display: flex;
      justify-content: space-between;

      .new-btn {
        margin-right: 20px;
        width: 100px;
        height: 40px;
      }

      .search {
        // /deep/ .ant-col-14 {
        //   width: 100%;
        // }
        // /deep/ input {
        //   border-radius: 50px;
        //   height: 36px;
        //   width: 100%;
        //   // border: 1px solid black;
        // }
        /deep/ .ant-input-affix-wrapper .ant-input {
          // width: 300px;
          border-radius: 30px;
        }
      }

      .rzj {
        display: inline-block;
        border: 1px solid #c0c0c0;
        color: #c0c0c0;
        line-height: 18px;
        font-size: 6px;
        padding-left: 5px;
        padding-right: 5px;
        cursor: pointer;
      }

      .zjselect {
        border: 1px solid red;
        color: red;
        background-color: #fff;
      }

      .yzj {
        display: inline-block;
        line-height: 18px;
        font-size: 6px;
        padding-left: 5px;
        padding-right: 5px;
        border: 1px solid var(--ThemeColor);
        color: var(--ThemeColor);
        background-color: #fef7f1;
        cursor: pointer;
      }

      .mj {
        /deep/ .ant-col-14 {
          width: 72.333333%;
        }
      }

      .zj {
        /deep/ .ant-col-14 {
          width: 74.333333%;
        }
      }

      /deep/ .ant-form-item {
        margin-bottom: 10px;
      }
    }

    .ant-row {
      .ant-col-6 {
        .ant-col-14 {
          width: 73%;
        }
      }
    }
  }

  .midhr {
    width: 100%;
    height: 5px;
    background-color: #f2f6fc;
  }

  .content {
    .img {
      width: 120px;
      height: 120px;
    }

    padding-top: 20px;

    /deep/ .ant-tabs-tab-active {
      background-color: var(--ThemeColor);
      color: #fff !important;
      border-radius: 5px;
    }
  }

  .rq {
    /deep/ .ant-col-14 {
      width: 80%;
    }
  }

  .topcenter {
    position: fixed;
    top: 43%;
    left: 50%;
  }

  .dateli {
    margin-top: 15px;
    margin-bottom: 15px;
    text-align: right;
    margin-right: 30px;
  }
}

.area-ipt {
  width: 80px;
}

.rent-box {
  display: flex;

  /deep/ .ant-form-item-children {
    display: flex;
    // width: 380px;
  }
}
</style>
